module.exports = __webpack_public_path__ + "img/i02.c9a9f473.svg";